

















































































































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import CourseList from '../pages/CourseList.vue'
import DashboardChart from './DashboardChart.vue'
import SubPage from '../atoms_molecules/SubPage.vue'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import Banner from '../../../api/v2/models/banner'
import Exam from '../organisms/Exam.vue'
import Enrollment from '../../../api/v2/models/enrollment'
import UserGoal from '../../../api/v2/models/user_goal'
import CourseMy from '../atoms_molecules/CourseMy.vue'
import DashboardProgress from '../atoms_molecules/DashboardProgress.vue'
import InformationView from '../atoms_molecules/InformationView.vue'
import DashboardTimeSummary from '../atoms_molecules/DashboardTimeSummary.vue'
import UserTimeGoalChangeDialog from '../atoms_molecules/UserTimeGoalChangeDialog.vue'
import api from '../../../api/v2/api'
import { subWeeks, getISODay, format, addDays } from 'date-fns'
import UserTrackingData from '../../../api/v2/models/user_tracking_data'
import { userState } from '../../stores/user'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'
import { sortedUniq, sum, round, max, min } from 'lodash'
import Information from '../../../api/v2/models/information'
import ExamModel from '../../../api/v2/models/exam'
import { convertMinutesToTimeJp } from '../../../../lib/convert'
import { examMyState } from '../../stores/exam_my'
import { PageModeType } from '../../types'

@Component({
  components: {
    CourseList,
    DashboardChart,
    Exam,
    CourseMy,
    DashboardProgress,
    DashboardTimeSummary,
    UserTimeGoalChangeDialog,
    InformationView,
    SubPage
  }
})
export default class Dashboard extends Vue {
  mobile = checkMobile()

  banners: Banner[] = []

  get user() {
    return userState.user
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  get customTexts() {
    return headerState.customTexts
  }

  exams: ExamModel[] = []

  get isMoreExam() {
    return this.exams.length > 3
  }

  enrollments: Enrollment[] = []
  get firstEnrollments() {
    return this.enrollments.slice(0, 3)
  }

  userGoal: UserGoal | null = null
  get currentUserGoal() {
    return this.userGoal
  }

  userGoalsCount: number = 0
  totalUserGoalsCount() {
    return this.userGoalsCount - 1 > 0 ? this.userGoalsCount - 1 : 0
  }

  get isMoreCourse() {
    return this.firstEnrollments.length < this.enrollments.length
  }

  get unreadInformations() {
    return this.user ? this.user.unreadInformations : []
  }
  get latestiUnreadInformations() {
    return this.user ? this.user.unreadInformations.slice(0, 3) : []
  }

  get learnTimeGoalMinutes() {
    return userState.user ? userState.user.learnTimeGoalMinutes : 0
  }

  get learnTimeToTimeJp() {
    return convertMinutesToTimeJp(this.learnTimeGoalMinutes)
  }

  // トラッキングデータ（api.tracking.getで取得）
  userTrackingData: UserTrackingData | null = null
  // アクティビティデータ（api.activity.getで取得）→ 学習完了数計算用
  activitiesData: any[] = []
  dateRange = {
    startDate: addDays(subWeeks(new Date(), 1), 1),
    endDate: new Date()
  }

  get timeGraphData() {
    if (!this.userTrackingData) {
      return null
    }
    return {
      labels: this.userTrackingData.labels.map((date) => {
        switch (getISODay(new Date(date))) {
          case 1:
            return '月'
          case 2:
            return '火'
          case 3:
            return '水'
          case 4:
            return '木'
          case 5:
            return '金'
          case 6:
            return '土'
          case 7:
            return '日'
        }
      }),
      datasets: [
        {
          label: '学習時間',
          backgroundColor: '#44a2eb',
          fill: false,
          data: this.userTrackingData.trackingUserValues
        }
      ]
    }
  }
  
  // DashboardChart.vue と同じロジックで、各日の学習完了数を算出する
  get computedActivityCount() {
    if (!this.userTrackingData || !this.userTrackingData.labels) {
      return 0
    }
    const dailyCounts = this.userTrackingData.labels.map((label: string) => {
      const dateStr = format(new Date(label), 'yyyy-MM-dd')
      const activitiesForDate = this.activitiesData.filter((act: any) => {
        const actDateStr = format(new Date(act.createdAt), 'yyyy-MM-dd')
        return actDateStr === dateStr
      })
      return activitiesForDate.length
    })
    return sum(dailyCounts)
  }

  // その結果を activityCount として利用
  get activityCount() {
    return this.computedActivityCount
  }

  get totalLearnTimeMinutes() {
    if (!this.userTrackingData) {
      return 0
    }
    return sum(this.userTrackingData.trackingUserValues)
  }

  get totalLearnTimeToTimeJp() {
    return convertMinutesToTimeJp(this.totalLearnTimeMinutes)
  }

  get learnProgressRate() {
    if (!this.learnTimeGoalMinutes) {
      return 0
    }
    return Math.round((this.totalLearnTimeMinutes / this.learnTimeGoalMinutes) * 100)
  }

  get consecutiveDayCount() {
    if (!this.userTrackingData) {
      return 0
    }
    return this.userTrackingData.consecutiveDayCount
  }

  get totalTime() {
    if (!this.userTrackingData) {
      return 0
    }
    let total = 0
    this.userTrackingData.trackingUserValues.forEach((value) => {
      total += value
    })
    return total
  }

  async updateTimeGoal(learnTimeGoalValue: number) {
    await userState.updateLearnTimeGoalValue({ learnTimeGoalValue })
  }

  pageMode: PageModeType = 'main_page'
  subPageExam: ExamModel | null = null
  onSwitchMode(pageMode: PageModeType) {
    this.pageMode = pageMode
    this.$router.push({
      query: {
        ...(this.$route.query ?? {}),
        exam_id: undefined
      }
    })
  }

  onShowHistories(exam: ExamModel) {
    this.pageMode = 'sub_page'
    this.subPageExam = exam
    this.$router.push({
      query: {
        ...(this.$route.query ?? {}),
        exam_id: exam.id.toString()
      }
    })
  }

  refetchList() {
    examMyState.getMyExams().then(() => {
      this.exams = examMyState.list
      if (this.$route.query['exam_id']) {
        const found = this.exams.find((item) => item.id.toString() === this.$route.query['exam_id'])
        if (found) {
          this.onShowHistories(found)
        }
      }
      if (this.subPageExam) {
        const found = this.exams.find((item) => item.id === this.subPageExam.id)
        if (found) {
          this.subPageExam = found
        }
      }
    })
  }

  created() {
    headerState.setTitle('ダッシュボード')
    footerState.setFooterDefault()
    this.refetchList()
    api.enrollment
      .index()
      .then((enrollments) => {
        this.enrollments = enrollments
      })
      .catch()
    api.banner
      .index({ type: 'user_dashboard' })
      .then((banners) => {
        this.banners = banners
      })
      .catch()
    // トラッキングデータの取得
    api.tracking
      .get(this.dateRange)
      .then((res) => {
        this.userTrackingData = res
      })
      .catch()
    // アクティビティデータの取得（学習完了数計算用）
    api.activity
      .get(0, this.dateRange)
      .then((res) => {
        this.activitiesData = res.activities || []
      })
      .catch()
    api.userGoal.currentGoal()
      .then((userGoal) => {
        this.userGoal = userGoal
      })
      .catch((e) => {
        console.log(e)
      })
    api.userGoal.index()
      .then((userGoals) => {
        this.userGoalsCount = userGoals.length
      })
      .catch((e) => {
        console.log(e)
      })
    userState.getUser()
  }

  getBanner(position) {
    return this.banners.find((banner) => banner.position === position)
  }

  get getSideBarBanner() {
    const banner = this.getBanner('user_dashboard_sidebar_top')
    return banner ? banner.bodyHtml : ''
  }

  dateFormat(date: any, formatDate: string = 'YYYY年MM月DD日') {
    return format(date, formatDate)
  }

  toActivity() {
    this.$router.push({
      name: ROUTER_NAME.ACTIVITY_LIST
    })
  }

  toInfo(info: Information) {
    this.$router.push({
      name: ROUTER_NAME.INFOR_DETAIL,
      params: { inforId: info.id.toString() }
    })
  }

  readInformation(info: Information) {
    api.infor.show(info.id.toString()).then(() => {
      userState.getUser()
    })
  }

  goToUserGoal(userGoal: UserGoal) {
    this.$router.push({
      name: ROUTER_NAME.USER_GOAL_DETAIL,
      params: { userGoalId: userGoal.id.toString() }
    })
  }

  goToUserGoals() {
    this.$router.push({ name: ROUTER_NAME.USER_GOAL_LIST })
  }
}
